module.exports = __webpack_public_path__ + "img/4X2A7871(4).5de6e2de.jpeg";